
export const DEFAULT_PROMPT = 'You have unsaved changes. Do you still want to **leave**?';

export const CANCEL_PROMPT = 'You have unsaved changes. Do you still want to **cancel**?';

export const NEW_IMPORT_PROMPT = 'Your import is not saved yet. Do you still want to **leave**?';

export const NEW_BOOKING_PROMPT = 'Your booking is not saved yet. Do you still want to **leave**?';

export const NEW_PROJECT_PROMPT = 'Your project is not saved yet. Do you still want to **leave**?';
export const NEW_PROJECT_UNIT_PROMPT = 'Your unit is not saved yet. Do you still want to **leave**?';
export const NEW_PROJECT_UNIT_LAYOUT_PROMPT = 'Your unit layout is not saved yet. Do you still want to **leave**?';

export const NEW_MAPPING_PROMPT = 'Your preset is not saved yet. Do you still want to **leave**?';

export const NEW_SPECIFICATION_PROMPT = 'Your preset is not saved yet. Do you still want to **leave**?';

export const NEW_CUSTOMER_PROMPT = 'Your customer details is not saved yet. Do you still want to **leave**?';
export const NEW_STAFF_PROMPT = 'Your staff details is not saved yet. Do you still want to **leave**?';

export const UPLOAD_DOCUMENT_PROMPT = 'Your document(s) is not uploaded yet. Do you still want to **leave**?';
export const UPLOAD_PICTURE_PROMPT = 'Your picture(s) is not uploaded yet. Do you still want to **leave**?';
export const UPLOAD_LOGO_PROMPT = 'Your logo(s) is not uploaded yet. Do you still want to **leave**?';

export const PREFERRED_BANKERS_PROMPT = 'Preferred banker(s) is not saved yet. Do you still want to **leave**?';




// WEBPACK FOOTER //
// ./src/constants/promptMessages.js